export const missingOptionDetailsText = {
  preloadFlow: {
    title: 'Update unavailable options',
    description: 'Unfortunately, some configurations are unavailable. Please update your options.',
  },
  summaryValidationFlow: {
    title: 'Update unselected options',
    description: 'Unfortunately, the following configurations are not selected. Please update your options.',
  },
};
